import React, {useEffect, useRef, useState} from 'react';
import {observer} from 'mobx-react';
import {useStore} from '../../../stores';
import {getVirtualCameraConfig, setLivePushStop} from '../../../services';
import FlvPlayer from './FlvPlayer';
import './index.less';

const ExternalLivePage = (props) => {
    const store = useStore();
    const {} = props;
    const [scriptInfo, setScriptInfo] = useState({});

    useEffect(() => {
        getScriptInfo();

        window.addEventListener('beforeunload', onWindowClose);

        return () => {
            window.removeEventListener('beforeunload', onWindowClose);
        };
    }, []);

    const getScriptInfo = async () => {
        const scriptId = store.externalLiveInfo.script_id;
        const {errno, data} = await getVirtualCameraConfig({// 获取拉流地址
            script_id: scriptId
        });
        if (+errno === 0) {
            setScriptInfo(data);
        }
    };
    const onWindowClose = async e => {
        const scriptId = store.externalLiveInfo.script_id;
        await setLivePushStop({
            script_id: scriptId,
            is_error: false,
            reason: 'external live page close window'
        });
        e.preventDefault();
    };

    return (
        <div className="digital-external-livepage">
            <div className="video-container">
                <FlvPlayer url={scriptInfo.pull_path} />
            </div>
        </div>
    );
};
export default observer(ExternalLivePage);